import { render, staticRenderFns } from "./EnglishResumeEduHistoryCard.vue?vue&type=template&id=800390e8&scoped=true"
import script from "./EnglishResumeEduHistoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnglishResumeEduHistoryCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EnglishResumeEduHistoryCard.vue?vue&type=style&index=0&id=800390e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800390e8",
  null
  
)

export default component.exports